import { gql } from "graphql-request";

import { track } from "../utils/analytics";

import { axiosQuery } from "./axiosHelpers";
import { logger } from "./logger";

const PAYPAL_ENV = import.meta.env.VITE_PAYPAL_ENV;

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    paypal: any;
    paypalCheckoutReady?: () => void;
  }
}

interface StartPaypalExpressCheckoutOutput {
  token: string;
  url: string;
}

const START_PAYPAL_MUTATION = gql`
  mutation StartPaypalExpressCheckout(
    $returnUrl: String!
    $cancelUrl: String!
    $isUnitedStates: Boolean!
    $currency: String!
  ) {
    startPaypalExpressCheckout(
      returnUrl: $returnUrl
      cancelUrl: $cancelUrl
      isUnitedStates: $isUnitedStates
      currency: $currency
    ) {
      token
      url
    }
  }
`;

export const initPaypal = (componentId: string, paypalMerchantId: string) => {
  window.paypalCheckoutReady = function () {
    window.paypal.checkout.setup(paypalMerchantId, {
      environment: PAYPAL_ENV,
      container: componentId,
      size: "medium",
      color: "blue",
      shape: "pill",
      tagline: "false",
    });
  };
};

export const onPaypalStart = async (req: {
  returnUrl: string;
  cancelUrl: string;
  isUnitedStates: boolean;
  currency: string;
}) => {
  const { isUnitedStates, currency } = req;
  logger.debug("Calling Paypal initXO", { isUnitedStates, currency });
  window.paypal.checkout.initXO();

  try {
    const resp = await axiosQuery<{
      startPaypalExpressCheckout: StartPaypalExpressCheckoutOutput;
    }>("StartPaypalExpressCheckout", START_PAYPAL_MUTATION, req);

    const { url } = resp.startPaypalExpressCheckout;
    logger.debug("Calling Paypal startFlow", { isUnitedStates, currency });
    window.paypal.checkout.startFlow(url);
    track({
      event: "Modal Opened",
      payload: {
        cta: "paypal_checkout",
        action: "payment_method_added",
        location: "membership_onboarding",
      },
    });
  } catch (err) {
    window.paypal.checkout.closeFlow();
    throw err;
  }
};
